// ---------------------------------------------------------------------------
// What is left of the original admin tour: two names and a slug.
//
// The walkthrough itself moved to onboarding/guides/ and runs on the engine in
// onboarding/engine/. The dashboard checklist moved to readiness, which asks the
// database whether a thing is done instead of whether a row was once clicked,
// and the "who gets onboarding" question moved to the backend persona resolver.
//
// The legacy slug stays because it is where dismissal is recorded, and nobody's
// dismissed card should come back because we renamed a key.
// ---------------------------------------------------------------------------

import { ORIENTATION_QUICK } from './guides/orientation';
import { ADMIN_TOUR_SLUG, isGuideDone, normalizeProgress } from './progress';

export { ADMIN_TOUR_SLUG, normalizeProgress };

// The guide to fall back on when a persona's quick journey is still empty.
export const ADMIN_TOUR_GUIDE_ID = ORIENTATION_QUICK.id;

// True once the user has finished or explicitly left a guide.
export const isTourDone = isGuideDone;
